export default {"src":"/_next/static/media/Logo.c87e7d52.svg","height":71,"width":204,"blurWidth":0,"blurHeight":0};